"use client";

import { SwiperSlide } from "swiper/react";
import SwiperCarousel from "@/components/plugins/swiper/SwiperCarousel";
import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";
import TextContent from "@/components/typography/TextContent";
import Button from "@/components/ui/Button";
import Image from "next/image";

import imgPros1 from "@/assets/images/screens/homepage/profit-pros-1.png";
import imgPros2 from "@/assets/images/screens/homepage/profit-pros-2.png";
import imgPros3 from "@/assets/images/screens/homepage/profit-pros-3.png";
import imgPros4 from "@/assets/images/screens/homepage/profit-pros-4.png";
import imgPros6 from "@/assets/images/screens/homepage/profit-pros-6.png";
import DrawProfitPros from "@/screens/homepage/components/drawings/DrawProfitPros";
import { useLeadModal } from "@/contexts/leadModal";

export default function ProfitPros() {
  const leadModal = useLeadModal();

  const slides = [
    {
      image: imgPros1,
      title: "Zabezpieczenie przychodu min. na poziomie 8%,",
      content: "a prognozujemy, że możesz zarobić nawet 12,1% w skali roku",
    },
    {
      image: imgPros2,
      title: "Model podziałowy 70/30",
      content:
        "Właściciel inwestycji otrzymuje 70% przychodów z wynajmu, a operator hotelowy 30%",
    },
    {
      image: imgPros3,
      title: "Bezobsługowa inwestycja",
      content: "W pełni zarządzana przez doświadczonego operatora",
    },
    {
      image: imgPros4,
      title: "Aż 21 dni pobytu właścicielskiego",
      content:
        "Tyle korzystasz ze swojego apartamentu – w tym 7 dni w sezonie wysokim",
    },
    {
      image: imgPros6,
      title: "Umowa Najmu 10+5",
      content: "Umowa na 10 lat z możliwością przedłużenia o kolejne 5 lat",
    },
  ];
  return (
    <div className="bg-[#F8F7FA] pb-16 pt-12 lg:pb-24 lg:pt-24">
      <div className="mb-7 lg:mb-10">
        <div className="m-auto max-w-screen-sm px-5">
          <div className="relative z-10">
            <TextSubHeader>
              <h2>Unikalny model biznesowy</h2>
            </TextSubHeader>
            <TextHeader>
              <span className="relative z-10">Poznaj </span>
              <span className="relative inline-block">
                <span>korzyści,</span>
                <DrawProfitPros className="absolute -left-2 -right-5 top-0" />
              </span>{" "}
              <span className="relative z-10">jakie oferujemy inwestorom!</span>
            </TextHeader>
            <TextContent>
              Wypoczywaj we własnym apartamencie w górach korzystając z pobytów
              właścicielskich i zarabiaj na wynajmie, gdy z nieruchomości nie
              korzystasz. Dzięki umowie operatorskiej Twoja inwestycja pozostaje
              w pełni bezobsługowa – apartamentem zarządzają profesjonaliści,
              podczas gdy Ty sprawdzasz jedynie wpłaty na konto.
            </TextContent>
          </div>
        </div>
      </div>
      <div className="mb-16 lg:mb-16">
        <SwiperCarousel
          className="!pr-32 lg:!pr-24"
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 0,
              slidesOffsetAfter: -128,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 0,
              slidesOffsetAfter: -96,
            },
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <Image src={slide.image} alt={""} className="w-full" />
              <div className="mt-5 px-5 text-[16px]/[24px] lg:text-[18px]/[24px]">
                <div className="mb-4 font-semibold">{slide.title}</div>
                <div>{slide.content}</div>
              </div>
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </div>
      <div
        className="flex justify-center px-5"
        onClick={() => leadModal.setFlow({ flow: "default" })}
      >
        <Button theme="black" inverse={true}>
          Dowiedz się więcej
        </Button>
      </div>
    </div>
  );
}
